import React from 'react';
import { FadeIn } from './FadeIn';
export const ProblemAgitation = () => {
  const problems = ['Вам сказали — операция, но что-то внутри сопротивляется и просит проверить еще раз.', 'Один врач говорит одно, другой — другое. Кому верить?', 'Не понятно: это действительно срочно или можно подождать и попробовать лечение?', 'Снова ехать в клинику, сидеть в очереди, заново всё рассказывать — нет сил.'];
  return <section className="py-24 bg-beigeLight" data-id="element-249">
      <div className="max-w-4xl mx-auto px-6" data-id="element-250">
        <FadeIn data-id="element-251">
          <h2 className="font-serif text-3xl md:text-4xl text-navy text-center mb-16" data-id="element-252">
            Знакомая ситуация?
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-253">
          {problems.map((problem, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-254">
              <div className="bg-white p-8 rounded-2xl shadow-card h-full flex items-start gap-4" data-id="element-255">
                <div className="w-2 h-2 rounded-full bg-sage mt-2.5 shrink-0" data-id="element-256" />
                <p className="text-lg text-navyLight leading-relaxed" data-id="element-257">
                  {problem}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-258">
          <div className="text-center max-w-2xl mx-auto" data-id="element-259">
            <p className="text-xl md:text-2xl font-serif text-navy italic" data-id="element-260">
              "Это нормально — сомневаться. На кону ваша спина и качество жизни
              на годы вперёд."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
};